import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'
import { BASE_ROUTE_URL } from '@/constants/config'

function guestGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  if (isAuthenticated && !to.meta.redirectIfLoggedIn) return next()

  if (isAuthenticated) {
    // In Flutter WebView (mv=1), client-side redirect may not update the page; use full page redirect
    if (to.query.mv === '1' && typeof window !== 'undefined') {
      const path = (`${BASE_ROUTE_URL}dashboard`).replace(/(\/)+/g, '/')
      window.location.href = `${window.location.origin}${path}?mv=1`
      return next(false)
    }
    return next({ name: 'owner:home', query: to.query })
  }
  return next()
}

export default guestGuard
